export class DataContract {

    async queryData(query = null) {
        throw new Error(`${this.constructor.name}: queryData(query) is not implemented.`);
    }

    async readData(publicId) {
        throw new Error(`${this.constructor.name}: readData(publicId) is not implemented.`);
    }

    async createData(data) {
        throw new Error(`${this.constructor.name}: createData(data) is not implemented.`);
    }

    async updateData(publicId, data) {
        throw new Error(`${this.constructor.name}: updateData(publicId, data) is not implemented.`);
    }

    async deleteData(publicId) {
        throw new Error(`${this.constructor.name}: deleteData(publicId) is not implemented.`);
    }

}
